import i18n from 'i18n';
import {
  ValueGetterParams,
  ITooltipParams,
  ColDef,
} from '@ag-grid-enterprise/all-modules';

interface OptionValue {
  key:string,
  value:string | boolean | number
}

interface Field {
  options?: OptionValue[]
}

export default function getFieldOptionFromFirstInterfaceNameValueGetter<T, U extends Field>(
  interfaceName: keyof T,
): (params: Partial<ValueGetterParams> | Partial<ITooltipParams>) => string {
  return ({ data, colDef }: Partial<ValueGetterParams> | Partial<ITooltipParams>): string => {
    const accessFunction = data as T;
    const [interfaceData] = (accessFunction[interfaceName] || []) as U[];

    if (!interfaceData) {
      return i18n.t('common.grid.empty');
    }

    const { options } = interfaceData;

    if (!options) {
      return i18n.t('common.grid.empty');
    }

    const option = options.find(({ key }) => key === (colDef as ColDef).field);
    return option?.value.toString() ?? i18n.t('common.grid.empty');
  };
}
